export const ADD_POST = "ADD_POST";
export const DELETE = "DELETE";
export const TAKE_INPUT_VALUES = "TAKE_INPUT_VALUES";
export const CHANGE_INPUT_VALUES = "CHANGE_INPUT_VALUES";
export const EMPTY_INPUT_VALUES = "EMPTY_INPUT_VALUES";
export const EDITING = "EDITING";
export const SHOW_TOOLTIP = "SHOW_TOOLTIP";
